<template>
  <div class="dict">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('withholdingList.withholdInfoAdd.title') }}
          </div>
        </template>
        <div class="collapse-content">
          <withholdInfo
            v-bind:accruedInfo="accruedInfo"
            :canEdit="canEdit"
            :currencyList="currencyList"
            :companyList="companyList"
            @updateForm="updateForm"
            @resetRowInfo="resetRowInfo"
            ref="accruedInfo"
          />
        </div>
      </el-collapse-item>
      <div class="m-b">
        <el-tabs type="card" v-model="activeNameTab" class="common-tab">
          <el-tab-pane :label="$t('withholdingList.inboundLine.title')" name="first">
            <inboundLine
              :canEdit="canEdit"
              :validateForm="validateForm"
              :departmentList="departmentList"
              ref="inboundLineInfo"
              :exchangeRate="accruedInfo.exchangeRate"
              :accruedInfo="accruedInfo"
            />
          </el-tab-pane>
          <el-tab-pane name="voucherTab" :label="$t('addInvoice.invoiceLine.title2')">
            <voucher
              ref="voucher"
              :voucherList="voucherList"
              @reverseInfo="reverseInfo"
              @postInfo="postInfo"
              @doConfirmInfo="doConfirmInfo"
            ></voucher>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!--编辑 -->
      <el-button
        v-hasPermi="['2021111917280194565']"
        :disabled="
          (['Saved', 'Rejected'].indexOf(accruedInfo.docStatus) == -1 && !canEdit) ||
          !accruedInfo.docStatus
        "
        type="primary"
        @click="edit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.edit') }}
      </el-button>
      <!-- 保存 -->
      <el-button
        :disabled="
          ['', 'Saved', 'Rejected', 'Approved'].indexOf(accruedInfo.docStatus) == -1 || !canEdit
        "
        type="primary"
        v-hasPermi="['2021111917281892766']"
        @click="save"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.save') }}</el-button
      >
      <!-- 提交审批 -->
      <el-button
        v-if="accruedInfo.docStatus == 'Approved'"
        :disabled="['Saved', 'Rejected'].indexOf(accruedInfo.docStatus) == -1 || !canEdit"
        v-hasPermi="['2021111917283134724']"
        type="primary"
        @click="submit"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.submit') }}</el-button
      >
      <el-button
        v-else
        :disabled="['Saved', 'Rejected'].indexOf(accruedInfo.docStatus) == -1"
        type="primary"
        @click="submit"
        v-hasPermi="['2021111917283134724']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.submit') }}</el-button
      >
      <el-button
        :disabled="['Approved'].indexOf(accruedInfo.docStatus) == -1"
        type="primary"
        v-hasPermi="['2021111917284127163']"
        @click="doConfirm"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.confirm') }}</el-button
      >
      <!-- 生成凭证 只有已确认状态才能点击生成凭证按钮。-->
      <el-button
        :disabled="
          ['Confirmed'].indexOf(accruedInfo.docStatus) == -1 ||
          ['notgenerate', 'generated', 'postError'].indexOf(accruedInfo.accountingStatus) == -1
        "
        type="primary"
        v-hasPermi="['2021111917290363327']"
        @click="handleAccountEntry"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.generateCredentials') }}</el-button
      >
      <!-- 过账凭证 只有已确认状态才能点击生成凭证按钮。-->
      <el-button
        :disabled="
          ['Confirmed'].indexOf(accruedInfo.docStatus) == -1 ||
          ['generated', 'postError'].indexOf(accruedInfo.accountingStatus) == -1
        "
        type="primary"
        v-hasPermi="['2021111917291710250']"
        @click="doSyncVoucherForEntityData()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.doSyncVoucher') }}</el-button
      >
      <!-- 撤回 只有单据状态为“已通过”的预提单才能点击该按钮-->
      <el-button
        :disabled="['Approved'].indexOf(accruedInfo.docStatus) == -1"
        type="primary"
        v-hasPermi="['2021111917292619063']"
        @click="doWithdraw"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.doWithdraw') }}</el-button
      >
      <!-- 冲销 单据状态为：已确认的单据才能点击冲销按钮。-->
      <el-button
        :disabled="['Confirmed'].indexOf(accruedInfo.docStatus) == -1"
        type="primary"
        v-hasPermi="['2021111917293567691']"
        @click="doReverseAccountEntry()"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('withholdingList.btns.writeOff') }}</el-button
      >
    </div>
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/financeCenter/withholding';
  import DataBaseAPI from '@/api/dataBase';
  import withholdInfo from './components/withholdInfo';
  import inboundLine from './components/inboundLine';
  import loading from '@/common/js/load.js'; //loading
  // import baseForm from '@/components/form/base-form';
  import voucherMixins from '@/common/mixins/voucher.js';
  import XEUtils from 'xe-utils';
  export default {
    components: {
      withholdInfo,
      inboundLine,
      // baseForm,
    },
    name: 'withholdingAdd',
    mixins: [voucherMixins],
    data() {
      const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
      return {
        voucherFlag: 'AE_AP_ACCRUED', //凭证标识
        activeNameTab: 'first',
        load: false,
        flag: this.$route.query.flag,
        activeNames: ['1', '2'],
        orderInfo: {},
        accruedInfo: {
          docStatus: '', //单据状态
          detailList: [], //入库批次明细/销售提单
          exchangeRateDate: date,
          docDate: date, //申请日期
        },
        companyList: [], //公司列表
        departmentList: [], // 部门列表
        // taxRateList:[],//率
        // delList:[],// 行删除列表
        accruedCompanyCode: '', //申请公司CODE
        dialogVisible: false,
        canEdit: this.$route.query.isEdit == 'Y',
        copy: this.$route.query.copy == false,
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        currencyList() {
          return this.$baseRequest.getDictListByType('all_currency');
        },
      }),
      reverseDataOptions() {
        return [
          {
            //冲销原因
            prop: 'reverseReason',
            span: 12,
            label: this.$t('withholdingList.withholdInfoAdd.column.accountingStatus'),
            type: 'dict',
            dictType: 'reverse_reason',
            clearable: true,
            required: true,
          },
          {
            // 冲销入账日期
            prop: 'reversePostDate',
            type: 'date',
            span: 12,
            label: this.$t('withholdingList.withholdInfoAdd.column.reversePostDate'),
            clearable: true,
            disabled: this.reverseData.reverseReason == 'N',
          },
        ];
      },
    },
    mounted() {
      this.getCompany();
      if (this.$route.query.query) {
        this.query = JSON.parse(this.$route.query.query);
        this.accruedInfo = JSON.parse(JSON.stringify(this.accruedInfo));
      }
      if (this.$route.query.id) {
        this.getDetail(this.$route.query.id);
      } else {
        this.accruedInfo.accruedCompanyCode = this.userInfo.companyCode;
        this.accruedInfo.accruedCompanyName = this.userInfo.companyName;
        this.accruedInfo.accruedDepartmentCode = this.userInfo.departmentCode;
        this.accruedInfo.accruedDepartmentName = this.userInfo.departmentName;
      }
    },
    methods: {
      // 获取详情信息
      getDetail(id = this.accruedInfo['id']) {
        loading.startLoading();
        let api = API.ACCRUED_QUERYBYID;
        if (this.$route.query.copy == true) {
          api = API.ACCRUED_COPY;
        }
        this.$axios
          .get(`${api}/${id}`)
          .then((res) => {
            loading.endLoading();
            if (0 == res.data.code) {
              // 获取凭证ID 获取凭证列表
              this.entityDataId = id;
              console.log(this.entityDataId);
              this.getAccountEntry();

              this.accruedInfo = res.data.data;
              this.accruedInfo.currencyName = this.currencyList.find(
                (i) => i.currencyCode === this.accruedInfo.currencyCode
              ).currencyName;
              let formData = this.filterEmpty(this.accruedInfo);
              XEUtils.lastObjectEach(formData, (item, key) => {
                this.$refs.accruedInfo.formData[key] = item;
              });
              this.accruedCompanyCode = res.data.data.accruedCompanyCode;
              this.$refs['accruedInfo'].getdepartmentList(this.accruedInfo.accruedCompanyCode);
              this.$refs.inboundLineInfo.indoundDetailList = res.data.data.detailList;
            } else {
              this.$alert(res.data.msg);
            }
          })
          .catch(() => loading.endLoading());
      },
      //获取公司信息
      async getCompany() {
        const selectStatus = await this.$axios.get(
          DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
        }
      },
      resetRowInfo() {
        delete this.accruedInfo.detailList;
        XEUtils.set(this.accruedInfo, 'detailList', []);
        this.$forceUpdate();
        this.$nextTick(() => {
          this.$refs.inboundLineInfo.indoundDetailList = [];
        });
      },
      //更新表单信息
      updateForm(formData) {
        // }
        setTimeout(() => {
          this.accruedInfo = Object.assign(this.accruedInfo, formData);
          this.$nextTick(() => {
            let detailList = this.$refs.inboundLineInfo.$refs.indoundList.getTableData().fullData;
            this.$refs.inboundLineInfo.upTableData(detailList);
          });
        }, 100);
      },
      // 校验表单
      validateForm() {
        return new Promise((resolve) => {
          this.$refs.accruedInfo.$refs.formData.handleSubmit().then(() => {
            resolve(true);
          });
        });
      },
      // 编辑
      edit() {
        this.canEdit = true;
      },
      //保存
      async save() {
        let flag = await this.validateForm(); //校验表单
        if (!flag) return;
        let detailList = this.$refs.inboundLineInfo.$refs.indoundList.getTableData().fullData;
        if (detailList.length == 0) {
          this.$message({ showClose: true, type: 'error', message: '请添加行信息' });
          return;
        }
        detailList.forEach((i, index) => {
          i.saveUpdate = 1;
          i.lineNumber = index + 1;
          // i = this.$baseRequest.assignObj(i);
        });
        //预提原币总金额不等于预提明细行预提原币金额总和的话则提示报错
        let accruedAmountListTotal = 0;
        let isTotalTrue = true;
        detailList.map((item) => {
          accruedAmountListTotal += item.accruedAmount * 1;
        });
        if (
          this.$toFixedNumber(this.accruedInfo.accruedWithoutTaxAmount, 2) !=
          this.$toFixedNumber(accruedAmountListTotal, 2)
        ) {
          isTotalTrue = false;
        }
        if (!isTotalTrue) {
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('行预提原币金额总和不等于预提原币不含税金额，请核对'),
          });
          return;
        }
        let params = {
          ...this.accruedInfo,
          detailList: detailList,
        };
        params = this.$baseRequest.assignObj(params);
        this.saveData(params);
      },
      async saveData(params) {
        loading.startLoading();
        let res = await this.$axios.post(API.ACCRUED_SAVE, params);
        if (res) {
          loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('billDetail.message.saveSussess'),
            });
            this.getDetail(res.data.data.id);
          } else {
            this.$message({ showClose: true, type: 'error', message: res.data.msg });
          }
        } else {
          loading.endLoading();
        }
      },
      //提交审批
      async submit() {
        let flag = await this.validateForm(); //校验表单
        if (!flag) return;
        let detailList = this.$refs.inboundLineInfo.$refs.indoundList.getTableData().fullData;
        if (detailList.length == 0) {
          this.$message({ showClose: true, type: 'error', message: '请添加行信息' });
          return;
        }
        detailList.forEach((i, index) => {
          i.saveUpdate = i.id || i.id === 0 ? 2 : 1;
          i.lineNumber = index + 1;
          i = this.$baseRequest.assignObj(i);
        });
        //预提原币总金额不等于预提明细行预提原币金额总和的话则提示报错
        let accruedAmountListTotal = 0;
        let isTotalTrue = true;
        detailList.map((item) => {
          accruedAmountListTotal += item.accruedAmount * 1;
        });
        if (
          this.$toFixedNumber(this.accruedInfo.accruedWithoutTaxAmount, 2) !=
          this.$toFixedNumber(accruedAmountListTotal, 2)
        ) {
          isTotalTrue = false;
        }
        if (!isTotalTrue) {
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('行预提原币金额总和不等于预提原币不含税金额，请核对'),
          });
          return;
        }
        let params = {
          ...this.accruedInfo,
          detailList: detailList,
        };
        params = this.$baseRequest.assignObj(params);
        loading.startLoading();
        this.$axios
          .post(API.ACCRUED_SUBMIT_APPROVAL, params)
          .then((res) => {
            loading.endLoading();
            if (res.data.code === 0) {
              this.$message({ showClose: true, message: '提交审批成功', type: 'success' });
              this.goBack();
            } else {
              if (res.data.data && res.data.data.id) {
                this.getDetail(res.data.data.id);
              }
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          })
          .catch(() => loading.endLoading());
      },
      // async delet(){
      //   this.params ={docNo:this.accruedInfo.docNo};
      //   this.$confirmAction().then(() => {
      //       this.$axios.post(API.ACCRUED_DELETE, params).then(res => {
      //       if (0 == res.data.code) {
      //         this.$message({ showClose: true,  message: res.data.msg,  type: "success"  });
      //         this.goBack();
      //       } else {
      //         this.$alert(res.data.msg);
      //       }
      //     });
      //   })
      // },
      // 确认
      doConfirmInfo(info) {
        let params = { id: this.accruedInfo.id, ...info };
        this.$axios.post(API.DO_CONFIRM, params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: this.$t('message.success'),
              type: 'success',
            });
            this.getDetail(this.accruedInfo.id);
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 撤回
      async doWithdraw() {
        const params = {
          id: this.accruedInfo.id,
        };
        loading.startLoading();
        this.$axios
          .post(API.ACCRUED_WITHDRAW, params)
          .then((res) => {
            loading.endLoading();
            if (res.data.code == 0) {
              this.getDetail(this.accruedInfo.id);
            } else {
              this.$message({ showClose: true, type: 'error', message: res.data.msg });
            }
          })
          .catch(() => loading.endLoading());
      },
      //冲销
      async writeOff() {
        if (
          this.accruedInfo.accountingStatus != 'notgenerate' &&
          this.accruedInfo.reverseStatus == 'N'
        ) {
          this.dialogVisible = true;
        } else {
          this.$axios
            .post(API.ACCRUED_GENARATE_VOUCHER, { id: this.accruedInfo.id })
            .then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.closeDialog();
                this.getDetail(this.accruedInfo.id);
              } else {
                this.$alert(res.data.msg);
              }
            });
        }
      },
      closeDialog() {
        this.dialogVisible = false;
        // this.postDate = null;
      },
      selectTrue() {
        const accrued = {
          id: this.accruedInfo.id,
          reverseReason: this.reverseData.reverseReason, //冲销原因
          reversePostDate: this.reverseData.reversePostDate, //冲销日期
        };
        this.loading.startLoading();
        this.$axios.post(API.REVERSE_VOUCHER, accrued).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.closeDialog();
            this.getDetail(this.accruedInfo.id);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 返回
      goBack() {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
              title: '预提编辑',
            },
          },
          toPath: {
            path: '/withholding/withholdingList',
            name: 'withholdingList',
            meta: {
              keepAlive: true,
              title: '预提查询',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .procurement {
    .el-dialog__body {
      padding-top: 0 !important;
    }
    .main-content {
      padding-top: 0 !important;
      .vxe-toolbar {
        height: auto !important;
      }
    }
  }
</style>
